import i18n from '../i18n';
import { openExternal } from './openExternal';
import { isMacPlatform } from './keyboard';
import { cleanLink, isOpenLinkClick } from '../components/terminal/terminalLinks';

/**
 * Clickable URLs in one terminal (Terminal board card 4). `WebLinksAddon` is
 * the class from `@xterm/addon-web-links`. Ctrl+click (⌘+click) opens the
 * link in the browser — never a plain click, so a drag across a URL still
 * selects. While the pointer is on a link, the terminal's tooltip says so and
 * `hovered()` names it, for the right-click menu.
 */
export function loadWebLinks(term, WebLinksAddon) {
  let hovered = null;
  const mac = isMacPlatform();
  const hint = () => (mac ? i18n.t('terminalExt.linkHintMac', '⌘+click to open link') : i18n.t('terminalExt.linkHint', 'Ctrl+click to open link'));
  const addon = new WebLinksAddon(
    (event, uri) => {
      if (isOpenLinkClick(event, mac)) openExternal(cleanLink(uri));
    },
    {
      hover: (_event, uri) => {
        hovered = cleanLink(uri);
        if (term.element) term.element.title = hint();
      },
      leave: () => {
        hovered = null;
        if (term.element) term.element.title = '';
      },
    }
  );
  term.loadAddon(addon);
  return { addon, hovered: () => hovered };
}
